<template>
  <div id="red-point"
       v-show="getRedPoint.hasRedPoint"
       :class="[hasNumber ? 'number-point' : 'little-point']">{{ hasNumber ? getRedPoint.redPointNumber : '' }}</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'redPoint',
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getRedPoint'
    ]),
    hasNumber () {
      return this.getRedPoint.redPointNumber !== 0
    }
  }
}
</script>

<style scoped>
#red-point {}
.number-point, .little-point {
  position: absolute;
  display: inline-block;
  top: 5px;
  right: -8px;
  font-size: 11px;
  color: #fff;
  text-align: center;
  line-height: 17px;
  border-radius: 100%;
  background-color: #fe3824;
}
.number-point {
  top: 5px;
  right: -8px;
  width: 17px;
  height: 17px;
}
.little-point {
  top: 7px;
  right: 2px;
  width: 8px;
  height: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/red-point/red-point.vue